module.exports = __webpack_public_path__ + "static/media/logo.e715ca33.png";